import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { ManualAction, ManualGridItem } from 'src/app/model/manual';

@Component({
  selector: 'vvf-manuals-grid',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <table
      class="table  table-bordered table-responsive-md"
      *ngIf="loading || items?.length"
    >
      <thead>
        <tr>
          <th scope="col">
            {{ 'manualiGrid.description' | translate }}
          </th>
          <th scope="col">
            {{ 'manualiGrid.nomeFile' | translate }}
          </th>
          <th scope="col" class="text-center">
            {{ 'common.actions' | translate }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of items; let index = index; trackBy: trackByFn">
          <td class="align-middle">{{ item.descrizione }}</td>
          <td class="align-middle">
            <span class="text-secondary font-weight-bold"
              >{{ item.nomeFile }}
            </span>
          </td>
          <td class="text-center align-middle">
            <vvf-manuals-grid-actions
              [manuale]="item"
              [index]="index"
              (action)="action.emit($event)"
            ></vvf-manuals-grid-actions>
          </td>
        </tr>
      </tbody>
    </table>

    <ng-content></ng-content>
  `,
})
export class ManualsGridComponent {
  @Input() loading: boolean = false;
  @Input() items: ManualGridItem[] = [];
  @Output() action = new EventEmitter<ManualAction>();

  trackByFn = (index: number) => index;
}
